import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class WithoutAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }
  
  canActivate(): Promise<boolean> | boolean {
    if(!this.authService.isAuthenticated()) {
      return true;
    } else {
      return this.authService.getUserDetails().then(userDetails => {
        if(userDetails.type == 'vadmin') {
          this.router.navigate(['vadmin']);
          return false;
        } else if(userDetails.type == 'client') {
          // Mirrors the vadmin branch above. Without this, an already-logged-in
          // Client hitting /client-login would fall through to `return true`
          // at the bottom and see the login form again instead of being sent
          // back into the app — the same bug this guard already avoids for
          // vadmin and user.
          this.router.navigate(['client']);
          return false;
        } else if(userDetails.type == 'user') {
          if(Number(userDetails.user.must_change_pass) === 1) {
            // TECH-001 (BATCH 108): the admin asked for a new password → profile (dialog opens itself)
            this.router.navigate(['/user/profile']);
          } else if(userDetails.user.privacy_policy == 0) {
            // Redirect to Verdentum Privacy Policy Page
            this.router.navigate(['intro/verdentum_privacy']);
          } else if(userDetails.user.org_privacy_policy != 1) {
            // Redirect to Organization Privacy Policy Page
            this.router.navigate(['intro/org_privacy']);
          } else {
            // Redirect to User Page
            this.router.navigate(['user']);
          }
          return false;
        }

        return true;
      });
    }
  }
  
}